// extracted by mini-css-extract-plugin
export default {"list":"styles_list__5p2OJ","picture":"styles_picture__K5UPP","sold":"styles_sold__I938s","inStock":"styles_inStock__oC8fn"};